import React from 'react';
import { Wand2 } from 'lucide-react';

/** Live SSE stream of a Claude-generated chapter, rendered as paragraphs.
 *  Strips the leading `TITLE: ...` token line so writers see prose only. */
export function StreamingProse({ text }) {
  const cleaned = text.replace(/^\s*TITLE\s*:.*?(\n|$)/i, '').replace(/^\s+/, '');
  if (!cleaned) {
    return (
      <div className="rounded-md border border-primary/30 bg-primary/5 p-6 text-center not-italic">
        <div className="mb-2 inline-flex items-center gap-2 font-sans text-[13px] uppercase tracking-wider text-primary">
          <Wand2 className="h-3.5 w-3.5 animate-pulse" /> Claude is composing…
        </div>
        <p className="font-sans text-[13.5px] text-muted-foreground">
          Streaming tokens from Claude Sonnet 4.5. This usually takes 30–90 seconds for a full chapter.
        </p>
      </div>
    );
  }
  const paras = cleaned.split(/\n\n+/);
  return (
    <>
      <div className="mb-3 inline-flex items-center gap-2 rounded-sm border border-primary/30 bg-primary/5 px-2 py-1 font-sans text-[13px] uppercase tracking-wider text-primary not-italic">
        <Wand2 className="h-3 w-3 animate-pulse" /> Streaming… {Math.round(cleaned.length / 4)} tokens
      </div>
      {paras.map((p, i) => (
        <p
          key={`stream-${i}`}
          className={i === 0 ? 'first-letter:font-serif-novel first-letter:text-6xl first-letter:font-semibold first-letter:float-left first-letter:mr-2 first-letter:mt-1 first-letter:leading-[0.85] first-letter:text-primary' : ''}
        >
          {p}
          {i === paras.length - 1 ? <span className="caret-blink" /> : null}
        </p>
      ))}
    </>
  );
}
